module.exports = __webpack_public_path__ + "static/media/delivery guy.9975e563.png";